import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp, FaFilePdf } from "react-icons/fa";
import Loader from '../../../../../components/Loader/Loader';
import SelectFild from '../../../../../components/SelectFild/SelectFild';
import { Row, Col } from 'react-bootstrap';
import UploadWithSignature from '../../../../../components/UploadWithSignature/UploadWithSignature';
import SignaturePad from 'signature_pad';
import { postWhatOccurredStore } from '../../../../../apiservices/ApiServices';
import carImg from '../../../../../assets/images/car.png';

const VehicleRelated = ({ details, selectedCheckboxes, postUpdateData, aircraftTypes, airlineOperators, airport, aircraftRegistration, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [preImg, setPreImg] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const [signatureImg, setSignatureImg] = useState('');
    const canvasRef = useRef(null);
    const signaturePadRef = useRef(null);


    useEffect(() => {
        const canvas = canvasRef.current;
        initializeCanvas(canvas);

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const initializeCanvas = (canvas) => {
        // Set display size (CSS pixels)
        const displayWidth = 270;
        const displayHeight = 431;

        // Set actual size in memory (scaled to account for extra pixel density)
        const scale = window.devicePixelRatio || 1;
        canvas.width = displayWidth * scale;
        canvas.height = displayHeight * scale;

        // Normalize coordinate system to use CSS pixels
        canvas.style.width = `${displayWidth}px`;
        canvas.style.height = `${displayHeight}px`;

        const ctx = canvas.getContext('2d');
        ctx.scale(scale, scale);

        signaturePadRef.current = new SignaturePad(canvas, {
            backgroundColor: 'white',
            penColor: 'rgb(255, 0, 0)'
        });

        // Load car image
        const img = new Image();
        img.src = carImg;
        img.onload = () => {
            ctx.drawImage(img, 0, 0, displayWidth, displayHeight);
        };
    };

    const handleResize = () => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        // Save current signature
        const data = signaturePadRef.current.toDataURL();

        // Reinitialize canvas
        initializeCanvas(canvas);

        // Restore signature
        if (data !== carImg) {
            signaturePadRef.current.fromDataURL(data);
        }
    };

    const clearSignature = () => {
        if (signaturePadRef.current) {
            signaturePadRef.current.clear(); // clear SignaturePad strokes

            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');

            // Clear canvas pixels
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Redraw car image
            const img = new Image();
            img.src = carImg;
            img.onload = () => {
                const displayWidth = parseInt(canvas.style.width);
                const displayHeight = parseInt(canvas.style.height);
                ctx.drawImage(img, 0, 0, displayWidth, displayHeight);
            };

            setSignatureImg('');
        }
    };

    const dataURLToBlob = (dataURL) => {
        const parts = dataURL.split(';base64,');
        const contentType = parts[0].split(":")[1];
        const raw = window.atob(parts[1]);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);

        for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }

        return new Blob([uInt8Array], { type: contentType });
    };

    const initialValues = {
        id: '',
        vehicleEquipmentNo: '',
        vehicleType: '',
        driverDetails: '',
        licenseDetails: '',
        departmentOperatorName: '',
        aircraftInvolved: '',

        aircraftResCode: "",
        aircraftResNumber: "",
        aircraftType: "",
        airlineOperator: "",
        origin: '',
        destination: '',
        flightNumber: "",
        operationalImpact: "",

        damageCaused: '',
    };

    useEffect(() => {
        if (details?.what_occurred?.details?.["2"]?.[0]) {
            const detailItem = details.what_occurred.details["2"][0];

            const parsedData = JSON.parse(detailItem.data_json)?.[0] || {};

            setPreImg(detailItem.image_json);

            // Set Formik values
            formik.setValues({
                id: detailItem.id || '',
                vehicleEquipmentNo: parsedData.vehicleEquipmentNo || '',
                vehicleType: parsedData.vehicleType || '',
                driverDetails: parsedData.driverDetails || '',
                licenseDetails: parsedData.licenseDetails || '',
                departmentOperatorName: parsedData.departmentOperatorName || '',
                aircraftInvolved: parsedData.aircraftInvolved || '',

                aircraftResCode: parsedData.aircraftResCode || '',
                aircraftResNumber: parsedData.aircraftResNumber || '',
                aircraftType: parsedData.aircraftType || '',
                airlineOperator: parsedData.airlineOperator || '',
                origin: parsedData.origin || '',
                destination: parsedData.destination || '',
                flightNumber: parsedData.flightNumber || '',
                operationalImpact: parsedData.operationalImpact || '',

                damageCaused: parsedData.damageCaused || '',
            });
        }
    }, [details]);

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: "",
        onSubmit: async (values) => {
            let signatureBlob = null;

            if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
                const signatureDataUrl = canvasRef.current.toDataURL('image/png');
                signatureBlob = dataURLToBlob(signatureDataUrl);
                setSignatureImg(signatureDataUrl);
            }

            const selectedCatList = JSON.stringify(selectedCheckboxes);
            let param;

            if (values.aircraftInvolved == 'yes') {
                param = {
                    "vehicleEquipmentNo": values.vehicleEquipmentNo,
                    "vehicleType": values.vehicleType,
                    "driverDetails": values.driverDetails,
                    "licenseDetails": values.licenseDetails,
                    "departmentOperatorName": values.departmentOperatorName,
                    "aircraftInvolved": values.aircraftInvolved,

                    "aircraftResCode": values.aircraftResCode,
                    "aircraftResNumber": values.aircraftResNumber,
                    "aircraftType": values.aircraftType,
                    "airlineOperator": values.airlineOperator,
                    "origin": values.origin,
                    "destination": values.destination,
                    "flightNumber": values.flightNumber,
                    "operationalImpact": values.operationalImpact,

                    "damageCaused": values.damageCaused,
                };
            }
            else {
                param = {
                    "vehicleEquipmentNo": values.vehicleEquipmentNo,
                    "vehicleType": values.vehicleType,
                    "driverDetails": values.driverDetails,
                    "licenseDetails": values.licenseDetails,
                    "departmentOperatorName": values.departmentOperatorName,
                    "aircraftInvolved": values.aircraftInvolved,
                    "damageCaused": values.damageCaused,
                };
            }

            const formData = new FormData();
            formData.append('category_data', selectedCatList);

            formData.append('what_occurred_detail_id', details?.what_occurred?.details?.["2"]?.[0]?.id || '');
            formData.append('incident_header_id', details.header_id);
            const main_category = 2;
            const sub_category = selectedCheckboxes["2"];
            formData.append('category_id', main_category);

            formData.append('what_occurred_header_id', details?.what_occurred?.id);
            formData.append('sub_category_id', JSON.stringify(sub_category));


            const data_json = [];
            data_json.push(param);
            formData.append('data_json', JSON.stringify(data_json));

            if (signatureBlob) {
                formData.append('images[]', signatureBlob, 'signature.png');
            }

            uploadedFiles.forEach(file => {
                console.log('file.signatureData', file)

                if (file.originalFile.type === 'application/pdf') {
                    formData.append('images[]', file.originalFile);
                }

                if (file.signatureData) {
                    const blob = dataURLtoBlob(file.signatureData);
                    formData.append('images[]', blob, `signature_${file.originalFile.name}`);
                }
            });


            setLoadings(true);
            try {
                const res = await postWhatOccurredStore(formData);
                toast.success(res.data.message);
                postUpdateData();
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }

        },
    });


    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched, } = formik;

    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    return (
        <>
            <div className='GroupList fieldset'>
                <div className='toggle-button'>
                    <h2 className="listTitle">Vehicle/ Equipment Related Incidents</h2>
                    <div className='btnColaps'><FaChevronUp /></div>
                </div>
                <div className="formsBox subFilds">
                    <Row>
                        <Col md={4}>
                            <div className="form-group">
                                <label>Vehicle/Equipment No</label>
                                <input type="text"
                                    id="vehicleEquipmentNo"
                                    name="vehicleEquipmentNo"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.vehicleEquipmentNo}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.vehicleEquipmentNo && touched.vehicleEquipmentNo ? (
                                    <p className='errormsg'>{errors.vehicleEquipmentNo}</p>
                                ) : null}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label>Vehicle Type</label>
                                <input type="text"
                                    id="vehicleType"
                                    name="vehicleType"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.vehicleType}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.vehicleType && touched.vehicleType ? (
                                    <p className='errormsg'>{errors.vehicleType}</p>
                                ) : null}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label>Driver Details</label>
                                <input type="text"
                                    id="driverDetails"
                                    name="driverDetails"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.driverDetails}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.driverDetails && touched.driverDetails ? (
                                    <p className='errormsg'>{errors.driverDetails}</p>
                                ) : null}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label>License Details</label>
                                <input type="text"
                                    id="licenseDetails"
                                    name="licenseDetails"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.licenseDetails}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.licenseDetails && touched.licenseDetails ? (
                                    <p className='errormsg'>{errors.licenseDetails}</p>
                                ) : null}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label>Department / Operator Name</label>
                                <input
                                    type="text"
                                    name="departmentOperatorName"
                                    className="form-control"
                                    autoComplete="off"
                                    value={values.departmentOperatorName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.departmentOperatorName && touched.departmentOperatorName && (
                                    <p className="errormsg">{errors.departmentOperatorName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label>Aircraft Involved?</label>
                                <SelectFild
                                    Firstop="Select Aircraft Involved?"
                                    selectName='aircraftInvolved'
                                    options={[
                                        { name: 'No', id: 'no' },
                                        { name: 'Yes', id: 'yes' },
                                    ]}
                                    value={values.aircraftInvolved}
                                    onChange={(selectedOption) => setFieldValue("aircraftInvolved", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.aircraftInvolved && touched.aircraftInvolved && (
                                    <p className="errormsg">{errors.aircraftInvolved}</p>
                                )}
                            </div>
                        </Col>
                        {values.aircraftInvolved == 'yes' && (
                            <>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Aircraft Registration</label>
                                        <div className='selectwith_input'>
                                            <div className='selects'>
                                                <SelectFild
                                                    Firstop='Select'
                                                    selectName="aircraftResCode"
                                                    options={aircraftRegistration}
                                                    value={values.aircraftResCode}
                                                    onChange={(selectedOption) => setFieldValue("aircraftResCode", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="aircraftResNumber"
                                                value={values.aircraftResNumber}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                        {errors.aircraftResCode && touched.aircraftResCode && (
                                            <p className="errormsg">{errors.aircraftResCode}</p>
                                        )}
                                        {errors.aircraftResNumber && touched.aircraftResNumber && (
                                            <p className="errormsg">{errors.aircraftResNumber}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="Aircraft_Type">Aircraft Type</label>
                                        <SelectFild
                                            Firstop="Select Aircraft Type"
                                            selectName="aircraftType"
                                            options={aircraftTypes}
                                            value={values.aircraftType}
                                            onChange={(selectedOption) => setFieldValue("aircraftType", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.aircraftType && touched.aircraftType && (
                                            <p className="errormsg">{errors.aircraftType}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="Airline_Operator">Airline / Operator</label>
                                        <SelectFild
                                            Firstop="Select Airline / Operator"
                                            selectName="airlineOperator"
                                            options={airlineOperators}
                                            value={values.airlineOperator}
                                            onChange={(selectedOption) => setFieldValue("airlineOperator", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.airlineOperator && touched.airlineOperator && (
                                            <p className="errormsg">{errors.airlineOperator}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Origin</label>
                                        <SelectFild
                                            Firstop="Select Origin"
                                            selectName="origin"
                                            options={airport}
                                            value={values.origin}
                                            onChange={(selectedOption) => setFieldValue("origin", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.origin && touched.origin && (
                                            <p className="errormsg">{errors.origin}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Destination</label>
                                        <SelectFild
                                            Firstop="Select Origin"
                                            selectName="destination"
                                            options={airport}
                                            value={values.destination}
                                            onChange={(selectedOption) => setFieldValue("destination", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.destination && touched.destination && (
                                            <p className="errormsg">{errors.destination}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Flight Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="flightNumber"
                                            value={values.flightNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Operational Impact (delay/diversion)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="operationalImpact"
                                            value={values.operationalImpact}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        <Col md={4}>
                            <div className="form-group">
                                <label>Damage Caused</label>
                                <SelectFild
                                    Firstop='Select Damage Caused'
                                    selectName="damageCaused"
                                    options={[
                                        { name: 'No', id: 'no' },
                                        { name: 'Yes', id: 'yes' },
                                    ]}
                                    value={values.damageCaused}
                                    onChange={(selectedOption) => setFieldValue("damageCaused", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.damageCaused && touched.damageCaused && (
                                    <p className="errormsg">{errors.damageCaused}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className="fieldset">
                        <h1>Vehicle incursions & accidents</h1>
                        <div className="formsBox">
                            <div className='canvasbox'>
                                <canvas
                                    ref={canvasRef}
                                    style={{
                                        width: '270px',
                                        height: '431px',
                                        touchAction: 'none'
                                    }}
                                ></canvas>
                                <button className='btn btn-red' onClick={clearSignature} type="button">Clear</button>
                            </div>
                        </div>
                    </div>
                    <UploadWithSignature onFilesChange={setUploadedFiles} />

                    <div className='previewsimges'>
                        {preImg.map((fileUrl, index) => {
                            if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                return (
                                    <div key={index} className='imageboxs'>
                                        <div className='imgs pdfs'>
                                            <div>
                                                <div className="pdf-icon">
                                                    <FaFilePdf size={48} color="#e74c3c" />
                                                </div>
                                                <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                            </div>

                                        </div>
                                    </div>
                                );
                            }
                            return (
                                <div key={index} className='imageboxs'>
                                    <div className='imgs'>
                                        <img src={fileUrl} alt={`Image ${index + 1}`} />
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="button-boxs grid pt-2 pb-2">
                        <button type='submit' onClick={handleSubmit} className='btn btn-orange'>Submit</button>
                    </div>
                </div>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default VehicleRelated